import BaseApi from '../BaseApi';
// 电池箱左侧接口
let API='screenBatteryBox'
export default class BatteryBoxApi extends BaseApi {
  // ***************************电池信息begin***************************
  // 5.获取单次充电记录集合
  async batterChargeList(info) {
    return await this.get(`${API}/batterChargeList`, info);
  }
  // 5.获取单次充电记录集合
  async getBatteryChargerInfo(info) {
    return await this.get(`${API}/getBatteryChargerInfo`, info);
  }
  //故障信息
  async selectMalfunctionMessage(info) {
    return await this.get(`screenBatteryInfo/selectMalfunctionMessage`, info);
  }
  //电量数据
  async selectinformationdata(info) {
    return await this.get(`screenBatteryInfo/selectinformationdata`, info);
  }
  // ***************************电池信息end***************************
}
export const batteryBoxRight = new BatteryBoxApi();